(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wadl-cart-shipping-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('wadl-cart-shipping')) return;
  const root = window.Shopify?.routes?.root || '/';
  let address, initialized, timer, revision = 0, controller, cache, selected;
  let cartState;
  let locationTask, locationAttempted = false, addressRevision = 0;
  const elements = () => [...document.querySelectorAll('wadl-cart-shipping')].filter(el => el.ready);
  const visible = el => !el.closest('cart-drawer') || el.closest('cart-drawer').classList.contains('active');
  async function json(url, options = {}) {
    const response = await fetch(url, { credentials:'same-origin', ...options, signal: options.signal || AbortSignal.timeout(12000) });
    if (!response.ok) throw new Error('shipping_request');
    return response.json();
  }
  async function init(el) {
    if (address) return;
    try {
      const saved = JSON.parse(sessionStorage.getItem('wadl-shipping-address') || 'null');
      if (saved?.country === 'DE' && typeof saved.zip === 'string' && /^\d{5}$/.test(saved.zip)) address = {country:'DE',zip:saved.zip,estimated:saved.estimated === true};
    } catch (_) { /* Storage can be disabled. */ }
    if (address) return;
    const savedZip = (el.dataset.zipDefault || '').trim();
    address = { country:'DE', zip:/^\d{5}$/.test(savedZip) ? savedZip : '' };
  }
  async function locate(el) {
    if (address.zip || el.dataset.locate !== 'true' || elements().some(node => node.editing)) return;
    if (locationTask) return locationTask;
    if (locationAttempted) return;
    locationAttempted = true;
    try {
      const lastAttempt = Number(sessionStorage.getItem('wadl-shipping-location-attempt'));
      if (lastAttempt && Date.now() - lastAttempt < 600000) return;
      sessionStorage.setItem('wadl-shipping-location-attempt', String(Date.now()));
    } catch (_) {}
    const originalAddress = address, editToken = addressRevision;
    locationTask = (async () => {
      try {
        const response = await fetch('https://ipwho.is/?fields=success,country_code,postal', {credentials:'omit',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(7000)});
        if (!response.ok) return;
        const result = await response.json();
        if (result.success !== true || result.country_code !== 'DE' || !/^\d{5}$/.test(result.postal || '')) return;
        if (address !== originalAddress || addressRevision !== editToken) return;
        address = {country:'DE',zip:result.postal,estimated:true};
        try { sessionStorage.setItem('wadl-shipping-address',JSON.stringify(address)); } catch (_) {}
        cache = null; selected = null;
      } catch (_) {}
    })();
    await locationTask;
    locationTask = null;
  }
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de', {style:'currency',currency:cartState.currency || 'EUR'}).format(cents / 100);
  function syncAddress(el) {
    if (!el.editing) el.querySelector('[data-zip]').value = address.zip;
    el.querySelector('[data-destination]').textContent = address.zip ? address.zip + (address.estimated ? ' (' + el.dataset.estimatedLabel + ')' : '') : '—';
    const geoStatus = el.querySelector('[data-locate-status]');
    if (geoStatus) geoStatus.textContent = address.estimated ? geoStatus.dataset.success.replace('[zip]', address.zip) : '';
  }
  function state(el, message) {
    el.querySelector('[data-status]').textContent = message;
    el.querySelector('[data-status]').hidden = !message;
    el.querySelector('[data-rates]').hidden = true;
    el.querySelector('[data-total]').textContent = el.strings.unknown;
  }
  function progress(el, rates = []) {
    const threshold = Number(el.dataset.threshold);
    const show = el.dataset.progress === 'true' && address.country === 'DE' && cartState.currency === 'EUR' && threshold > 0 && cartState.items.some(item => item.requires_shipping);
    el.querySelector('[data-progress-wrap]').hidden = !show;
    if (!show) return;
    el.querySelector('progress').value = Math.min(100, cartState.total_price / threshold * 100);
    el.querySelector('[data-progress-wrap]').dataset.complete = String(rates.some(rate => rate.cents === 0));
    el.querySelector('[data-progress-text]').textContent = rates.some(rate => rate.cents === 0) ? el.strings.free : cartState.total_price >= threshold ? el.strings.reached : el.strings.remaining.replace('[amount]', money(threshold - cartState.total_price));
  }
  function render(el, rates) {
    state(el, '');
    progress(el, rates);
    const list = el.querySelector('[data-rate-list]');
    list.replaceChildren();
    el.querySelector('[data-rates]').hidden = false;
    if (!rates.some(rate => rate.key === selected)) selected = rates[0].key;
    rates.forEach(rate => {
      const label = document.createElement('label'); label.className = 'wcs-rate';
      const radio = document.createElement('input'); radio.type = 'radio'; radio.name = el.querySelector('[data-address]').id + '-rate'; radio.value = rate.key; radio.checked = rate.key === selected;
      const name = document.createElement('span'); name.textContent = rate.name;
      const price = document.createElement('strong'); price.textContent = money(rate.cents);
      radio.addEventListener('change', () => { selected = rate.key; elements().forEach(node => render(node, rates)); });
      label.append(radio, name, price); list.append(label);
    });
    el.querySelector('[data-total]').textContent = money(cartState.total_price + rates.find(rate => rate.key === selected).cents);
  }
  function schedule() {
    clearTimeout(timer); revision++; controller?.abort();
    elements().forEach(el => { state(el, el.strings.loading); el.querySelector('[data-progress-wrap]').hidden = true; });
    timer = setTimeout(refresh, 250);
  }
  async function refresh() {
    const nodes = elements();
    if (!nodes.some(visible)) return;
    const token = ++revision;
    controller?.abort(); controller = new AbortController();
    const signal = AbortSignal.any([controller.signal, AbortSignal.timeout(18000)]);
    nodes.forEach(el => state(el, el.strings.loading));
    try {
      initialized ||= init(nodes[0]); await initialized;
      const cart = await json(root + 'cart.js', {signal});
      if (token !== revision) return;
      cartState = cart;
      nodes.forEach(el => { el.hidden = cart.item_count === 0; syncAddress(el); el.querySelector('[data-subtotal]').textContent = money(cart.total_price); progress(el); });
      if (!cart.item_count) return;
      if (!cart.items.some(item => item.requires_shipping)) {
        nodes.forEach(el => { state(el, el.strings.no_shipping); el.querySelector('[data-total]').textContent = money(cart.total_price); }); return;
      }
      await locate(nodes.find(visible));
      if (token !== revision) return;
      nodes.forEach(syncAddress);
      if (address.country !== 'DE') { nodes.forEach(el => state(el, el.strings.unsupported)); return; }
      if (!/^\d{5}$/.test(address.zip)) {
        nodes.forEach(el => {
          state(el, el.strings.enter_zip);
        });
        return;
      }
      const key = JSON.stringify([cart.items,cart.total_price,cart.currency,address]);
      if (cache?.key === key && Date.now() - cache.time < 60000) { nodes.forEach(el => render(el, cache.rates)); return; }
      const params = new URLSearchParams({'shipping_address[country]':address.country,'shipping_address[zip]':address.zip});
      await json(root + 'cart/prepare_shipping_rates.json?' + params, {method:'POST',signal});
      let result;
      for (let attempt = 0; attempt < 16; attempt++) {
        if (token !== revision) return;
        result = await json(root + 'cart/async_shipping_rates.json?' + params, {signal});
        if (result?.shipping_rates) break;
        await new Promise(resolve => setTimeout(resolve, 500));
      }
      if (token !== revision) return;
      if (!result?.shipping_rates) throw new Error('shipping_timeout');
      const rates = result.shipping_rates.filter(rate => rate.price !== null && rate.price !== '' && Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0 && (!rate.currency || rate.currency === cart.currency)).map((rate,index) => ({key:rate.code + ':' + index,name:rate.presentment_name || rate.name,cents:Math.round(Number(rate.price)*100)})).sort((a,b) => a.cents - b.cents);
      if (!rates.length) { nodes.forEach(el => state(el, el.strings.unavailable)); return; }
      cache = {key,rates,time:Date.now()}; nodes.filter(el => el.isConnected).forEach(el => render(el,rates));
    } catch (_) {
      if (token === revision) nodes.filter(el => el.isConnected).forEach(el => state(el, el.strings.failed));
    }
  }
  class Shipping extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.strings = JSON.parse(this.dataset.strings);
      const panel = this.querySelector('[data-address]');
      const change = this.querySelector('[data-change]');
      change.addEventListener('click', () => {
        panel.hidden = !panel.hidden; this.editing = !panel.hidden;
        change.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden) { addressRevision++; this.querySelector('[data-zip]').focus(); }
        else syncAddress(this);
      });
      const calculate = () => {
        const zip = this.querySelector('[data-zip]').value.trim();
        if (!/^\d{5}$/.test(zip)) { this.querySelector('[data-zip]').reportValidity(); return; }
        addressRevision++; this.editing = false;
        address = {country:'DE', zip};
        try { sessionStorage.setItem('wadl-shipping-address', JSON.stringify(address)); } catch (_) {}
        cache = null; selected = null; panel.hidden = true; change.setAttribute('aria-expanded','false'); schedule();
      };
      this.querySelector('[data-calculate]').addEventListener('click', calculate);
      this.querySelector('[data-zip]').addEventListener('input', () => { addressRevision++; this.editing = true; });
      panel.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); calculate(); } });
      schedule();
    }
  }
  customElements.define('wadl-cart-shipping', Shipping);
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, {attributes:true,attributeFilter:['class']});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wadl-recommendations-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('wadl-recommendations')) return;
  const global = JSON.parse(document.getElementById('wadl-recs-global')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const copy = key => global.copy?.[key] || key;
  const historyKey = 'wadl.recommendations.history.v1';
  let trendSnapshot;
  try { trendSnapshot = JSON.parse(document.getElementById('wadl-recs-trends')?.textContent || '{}'); } catch { trendSnapshot = {}; }
  const currentTrends = (config, now = Date.now()) => {
    const age = now - Date.parse(trendSnapshot.generatedAt);
    if (!config.trendsEnabled || trendSnapshot.version !== 1 || !Number.isFinite(age) || age < -300000 || age > 72*3600000) return {};
    return trendSnapshot.scores && typeof trendSnapshot.scores === 'object' ? trendSnapshot.scores : {};
  };
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const recommendationCount = products => Math.max(1,4-new Set(products.map(String)).size);
  const allowed = () => {
    try { return !!global.personalize && Shopify.customerPrivacy?.preferencesProcessingAllowed() === true && Shopify.customerPrivacy?.marketingAllowed() === true; } catch { return false; }
  };
  const inSeason = (start, end, date = new Date()) => {
    const today = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).format(date);
    const valid = value => !value || /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0,10) === value;
    return valid(start) && valid(end) && (!start || today >= start) && (!end || today <= end) && (!start || !end || start <= end);
  };
  const rank = (candidates, config, mode, excluded, limit, now = Date.now()) => {
    const trends = currentTrends(config, now);
    const map = new Map();
    for (const candidate of candidates) {
      if (excluded.has(String(candidate.id))) continue;
      const old = map.get(candidate.id);
      if (old) for (const [key,value] of Object.entries(candidate.signals)) old.signals[key] = Math.max(old.signals[key] || 0,value);
      else map.set(candidate.id,{...candidate,signals:{...candidate.signals}});
    }
    const pool = [...map.values()].map(candidate => {
      const s = candidate.signals;
      const fresh = Math.max(0,1 - (now / 1000 - Number(candidate.published)) / (90 * 86400));
      const trend = Math.min(1,Math.max(0,Number(trends[candidate.id]) || 0));
      const scores = {auto:(s.relevance || 0)*config.relevance + (s.popularity || 0)*config.popularity + Math.min(1,fresh)*config.novelty + (s.season || 0)*config.season + trend*(Number(config.trend)||0), bestseller:(s.popularity || 0)*100,new:(s.novelty || 0)*100,seasonal:(s.season || 0)*100,manual:(s.manual || 0)*100};
      return {...candidate,score:(scores[mode] || 0)+(s.fallback || 0)*.01};
    });
    const result = [], kinds = new Map();
    while(pool.length && result.length < limit) {
      pool.sort((a,b) => (b.score - (mode === 'auto' ? (kinds.get(b.kind)||0)*2 : 0)) - (a.score - (mode === 'auto' ? (kinds.get(a.kind)||0)*2 : 0)) || String(a.id).localeCompare(String(b.id)));
      const next = pool.shift(); result.push(next); kinds.set(next.kind,(kinds.get(next.kind)||0)+1);
    }
    return result;
  };
  const cache = new Map();
  async function getHTML(url) {
    const absolute = new URL(url, location.origin);
    if (absolute.origin !== location.origin) throw Error('origin');
    const cached = cache.get(absolute.href);
    if (cached && Date.now() - cached.time < 60000) return cached.promise;
    const promise = fetch(absolute.href,{signal:AbortSignal.timeout(10000)}).then(response => {if(!response.ok) throw Error('fetch');return response.text();});
    cache.set(absolute.href,{time:Date.now(),promise});
    try { return await promise; } catch(error) {cache.delete(absolute.href);throw error;}
  }
  const parse = html => new DOMParser().parseFromString(html,'text/html');
  const feedURL = (path, params = {}) => {const url = new URL(root+path,location.origin);url.search = new URLSearchParams({section_id:'wadl-recommendation-feed',...params});return url;};
  const candidatesFrom = (html,signal) => [...parse(html).querySelectorAll('template[data-wr-candidate]')].map((template,index) => ({...template.dataset,id:template.dataset.id,template,signals:{[signal]:Math.max(.05,1-index/50)}}));
  function recentHandles() {
    if(!allowed()) return [];
    try {
      const history = JSON.parse(localStorage.getItem(historyKey) || '[]');
      const wishlist = JSON.parse(localStorage.getItem('wadl.wohnideen.v2') || '{}');
      const saved = wishlist.version === 2 && Array.isArray(wishlist.lists) ? wishlist.lists.slice(0,3).flatMap(list => Array.isArray(list.items) ? list.items.slice(0,100).map(item=>item.handle) : []) : [];
      return [...new Set([...saved,...(Array.isArray(history) ? history.filter(item => Date.now()-item.time < 30*86400000).map(item=>item.handle) : [])])].filter(validHandle).slice(0,3);
    } catch {return [];}
  }
  function remember() {
    if(typeof Shopify === 'undefined' || !Shopify.customerPrivacy) return;
    if(!allowed()) {try {localStorage.removeItem(historyKey);} catch {} return;}
    if(!validHandle(global.current?.handle)) return;
    try {
      const previous = JSON.parse(localStorage.getItem(historyKey) || '[]');
      const history = Array.isArray(previous) ? previous.filter(item=>validHandle(item.handle) && item.handle!==global.current.handle && Date.now()-item.time<30*86400000) : [];
      localStorage.setItem(historyKey,JSON.stringify([{handle:global.current.handle,time:Date.now()},...history].slice(0,12)));
    } catch {}
  }
  let cartRequest;
  function getCart() {
    if(!cartRequest) cartRequest = fetch(root+'cart.js',{signal:AbortSignal.timeout(10000)}).then(r=>{if(!r.ok)throw Error('cart');return r.json();}).finally(()=>{cartRequest=null;});
    return cartRequest;
  }
  class Recommendations extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-wr-context]').textContent);
      this.status = this.querySelector('[data-wr-status]');
      this.addEventListener('change',event=>{event.stopPropagation();const select=event.target.closest('[data-wr-variant]');if(!select)return;const card=select.closest('.wr-card'),option=select.selectedOptions[0];card.querySelector('[data-wr-price]').textContent=option.dataset.price;card.querySelector('[data-wr-add]').dataset.wrAdd=select.value;card.querySelectorAll('a').forEach(a=>{const url=new URL(a.href);url.searchParams.set('variant',select.value);a.href=url.href;});if(option.dataset.image){const image=card.querySelector('img');if(image){image.src=option.dataset.image;image.removeAttribute('srcset');}}},{signal:this.controller.signal});
      this.addEventListener('click',event=>{const button=event.target.closest('[data-wr-add]');if(button){event.preventDefault();this.add(button);}},{signal:this.controller.signal});
      this.drawer = this.closest('cart-drawer');
      if(!this.drawer || this.drawer.classList.contains('active')) this.load();
      else {this.observer = new MutationObserver(()=>{if(this.drawer.classList.contains('active')){this.observer.disconnect();this.load();}});this.observer.observe(this.drawer,{attributes:true,attributeFilter:['class']});}
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.version=(this.version||0)+1;}
    async load(cart) {
      const version = this.version = (this.version||0)+1;
      this.status.textContent=copy('loading');
      const wasPersonal = allowed();
      if(cart){this.config.cart=[...new Set(cart.items.map(item=>item.product_id))];this.config.empty=cart.item_count===0;}
      const is404=this.config.surface==='404';
      const empty=this.config.empty, mode=is404?'auto':(empty?global.emptyMode:global.filledMode)||'auto';
      const count=is404?Math.min(8,Math.max(2,Number(this.config.count)||8)):recommendationCount(this.config.cart);
      if(!is404)this.querySelector('.wr-heading').textContent=(empty?global.emptyHeading:global.filledHeading)||'';
      let intro=this.querySelector('.wr-intro');
      if(empty&&!intro&&!is404){intro=document.createElement('p');intro.className='wr-intro';this.prepend(intro);}
      if(intro){intro.hidden=!empty;intro.textContent=global.emptyText||'';}
      const excluded=new Set(this.config.cart.map(String));
      const tiles=[...this.querySelectorAll('[data-wr-season]')];
      const active=tiles.filter(tile=>inSeason(tile.dataset.start,tile.dataset.end));
      const seasons=(this.config.seasons||[]).filter(item=>validHandle(item.handle)&&inSeason(item.start,item.end));
      tiles.forEach(tile=>tile.hidden=true);
      const pool=[];
      const collect=async(url,signal)=>{try{const html=await getHTML(url);const results=candidatesFrom(html,signal);pool.push(...results);return html;}catch{return '';}};
      const fallback=validHandle(this.config.fallback)?this.config.fallback:'all';
      const bestsellers=validHandle(this.config.bestsellers)?this.config.bestsellers:'all';
      const jobs=[];
      if(mode==='auto'||mode==='bestseller') jobs.push(collect(feedURL('collections/'+bestsellers,{sort_by:'best-selling'}),'popularity'));
      if(mode==='auto'||mode==='new') jobs.push(collect(feedURL('collections/'+fallback,{sort_by:'created-descending'}),'novelty'));
      if(mode==='auto'||mode==='seasonal') seasons.forEach(item=>jobs.push(collect(feedURL('collections/'+item.handle,{sort_by:'best-selling'}),'season')));
      if(mode==='manual') this.config.manual.slice(0,8).filter(validHandle).forEach((handle,index)=>jobs.push(collect(feedURL('products/'+handle),'manual').then(()=>{const found=pool.find(p=>p.handle===handle);if(found)found.signals.manual=1-index/10;})));
      if(mode==='auto') {
        const seedIds=this.config.cart.slice(0,3).map(String);
        if(!seedIds.length && global.current?.id) seedIds.push(String(global.current.id));
        const recs=async id=>{if(!/^\d+$/.test(id))return;await collect(feedURL('recommendations/products',{product_id:id,intent:'related',limit:10}),'relevance');await collect(feedURL('recommendations/products',{product_id:id,intent:'complementary',limit:10}),'relevance');};
        jobs.push(...seedIds.map(recs));
        if(this.config.personalize && wasPersonal) jobs.push(...recentHandles().slice(0,2).map(async handle=>{try{const html=await getHTML(feedURL('products/'+handle));if(!allowed())return;const seed=parse(html).querySelector('[data-wr-seed]')?.dataset.wrSeed;if(seed&&!seedIds.includes(seed))await recs(seed);}catch{}}));
      }
      await Promise.allSettled(jobs);
      if(mode==='auto'&&Object.keys(currentTrends(this.config)).length){
        const existing=new Set(pool.map(item=>String(item.id)));
        const seeds=(Array.isArray(trendSnapshot.seeds)?trendSnapshot.seeds:[]).filter(item=>/^\d+$/.test(item.id)&&validHandle(item.handle)&&!existing.has(String(item.id))&&!excluded.has(String(item.id))).slice(0,8);
        await Promise.allSettled(seeds.map(item=>collect(feedURL('products/'+item.handle),'trend')));
      }
      if(new Set(pool.filter(item=>!excluded.has(String(item.id))).map(item=>item.id)).size<count) await collect(feedURL('collections/'+fallback,{sort_by:'best-selling'}),'fallback');
      for(let page=1;page<=3&&new Set(pool.filter(item=>!excluded.has(String(item.id))).map(item=>item.id)).size<count;page++) await collect(feedURL('collections/all',{sort_by:'best-selling',page}),'fallback');
      if(!this.isConnected||this.version!==version)return;
      if(wasPersonal&&!allowed()){this.load(cart);return;}
      const selected=rank(pool,this.config,mode,excluded,count);
      const cards=selected.map(item=>is404?item.template.content.querySelector('[data-wr-404]')?.content.cloneNode(true):item.template.content.querySelector('.wr-card')?.cloneNode(true)).filter(Boolean);
      if(cards.length||!is404)this.querySelector('[data-wr-products]').replaceChildren(...cards);
      this.dataset.personalized=String(wasPersonal);
      const tileCount=Number(empty?global.emptyTiles:global.filledTiles)||0;
      active.sort((a,b)=>selected.filter(p=>(p.collections||'').split(',').includes(b.dataset.wrSeason)).length-selected.filter(p=>(p.collections||'').split(',').includes(a.dataset.wrSeason)).length);
      active.slice(0,tileCount).forEach(tile=>tile.hidden=false);
      const collectionContainer=this.querySelector('[data-wr-collections]');
      if(collectionContainer)collectionContainer.hidden=!active.length||tileCount===0;
      this.status.textContent=selected.length?'':copy('none');
      this.dataset.ready='true';
    }
    async add(button) {
      if(this.busy)return;this.busy=true;button.disabled=true;button.textContent=copy('adding');
      const card=button.closest('.wr-card'), id=button.dataset.wrAdd;
      let sent=false,added=false;
      try {
        if(!/^\d+$/.test(id)||!validHandle(card.dataset.handle))throw Error('product');
        const policyURL=new URL(root+'products/'+card.dataset.handle,location.origin);policyURL.search=new URLSearchParams({section_id:'wadl-wohnideen-product',variant:id});
        const response=await fetch(policyURL,{signal:AbortSignal.timeout(10000)});if(!response.ok)throw Error('product');
        const doc=parse(await response.text()),policy=doc.querySelector('[data-wi-cart-policy]');
        const product=JSON.parse(doc.querySelector('[data-wi-product]')?.textContent||'{}');
        if(policy?.dataset.allowed!=='true'||policy.dataset.variant!==id||!product.variants?.some(v=>String(v.id)===id&&v.available))throw Error('product');
        const stockResponse=await fetch(feedURL('products/'+card.dataset.handle),{cache:'no-store',signal:AbortSignal.timeout(10000)});
        if(!stockResponse.ok)throw Error('stock');
        const freshTemplate=parse(await stockResponse.text()).querySelector('template[data-wr-candidate]');
        const freshCard=freshTemplate?.content;
        if(!freshCard?.querySelector('[data-wr-add]')||!freshCard.querySelector('[data-wr-add="'+id+'"], option[value="'+id+'"]'))throw Error('stock');
        const drawer=document.querySelector('cart-drawer');
        sent=true;
        const result=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname}),signal:AbortSignal.timeout(15000)});
        if(!result.ok){sent=false;throw Error('rejected');}
        const data=await result.json();added=true;cache.clear();
        if(drawer && data.sections?.['cart-drawer'] && data.sections?.['cart-icon-bubble']) {
          drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));drawer.classList.remove('is-empty');drawer.renderContents(data);
          setTimeout(()=>drawer.querySelector('.drawer__heading')?.focus?.(),250);
        }
        if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'wadl-recommendations',cartData:data});
        else document.dispatchEvent(new CustomEvent('wadl:recommendations-cart-updated'));
        this.status.textContent=copy('added');
      } catch(error) {
        this.status.textContent=added?copy('added'):sent?copy('uncertain'):copy('error');
        if(sent&&!added)button.dataset.uncertain='true';
      } finally {
        this.busy=false;button.disabled=button.dataset.uncertain==='true';button.textContent=copy('add');
      }
    }
  }
  customElements.define('wadl-recommendations',Recommendations);
  let pageVersion=0;
  async function syncCartPage() {
    const items=document.querySelector('main cart-items'),footer=document.getElementById('main-cart-footer');
    const itemsId=document.getElementById('main-cart-items')?.dataset.id,footerId=footer?.dataset.id;
    if(!items||!itemsId||!footerId)return;
    const version=++pageVersion;
    try {
      const url=new URL(root+'cart',location.origin);url.searchParams.set('sections',[itemsId,footerId].join(','));
      const response=await fetch(url,{signal:AbortSignal.timeout(10000)});if(!response.ok)throw Error('cart');
      const sections=await response.json();if(version!==pageVersion)return;
      const freshItems=parse(sections[itemsId]||'').querySelector('cart-items');
      const freshFooter=parse(sections[footerId]||'').querySelector('#main-cart-footer');
      if(freshItems){items.className=freshItems.className;items.innerHTML=freshItems.innerHTML;}
      if(freshFooter&&footer.isConnected)footer.replaceWith(freshFooter);
    }catch{}
  }
  const refresh=async()=>{try{const cart=await getCart();document.querySelectorAll('wadl-recommendations').forEach(el=>{if(!el.drawer||el.drawer.classList.contains('active'))el.load(cart);});}catch{}};
  const cartChanged=()=>{syncCartPage();refresh();};
  document.addEventListener('wadl:recommendations-cart-updated',cartChanged);
  if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,cartChanged);
  const privacyChanged=()=>{remember();if(!allowed())document.querySelectorAll('wadl-recommendations[data-personalized="true"]').forEach(el=>{el.querySelector('[data-wr-products]')?.replaceChildren();el.dataset.personalized='false';});refresh();};
  document.addEventListener('visitorConsentCollected',privacyChanged);
  window.addEventListener('storage',event=>{if(event.key==='wadl.wohnideen.v2'||event.key===historyKey)refresh();});
  if(window.Shopify?.loadFeatures) Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)privacyChanged();});
  remember();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wadl-wohnideen"] && !Shopify.designMode) return;
  try {
    (() => {
  const KEY = 'wadl.wohnideen.v2';
  const LEGACY_KEY = 'wadl.wohnideen.v1';
  const keyOf = item => `${item.handle}:${item.variant}`;
  const safeImage = value => {
    if (!value) return '';
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopify.com')) ? url.href : ''; } catch { return ''; }
  };
  function normalize(item) {
    if (!item || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(item.handle) || !/^\d{1,20}$/.test(String(item.variant))) return null;
    const clean = {handle:item.handle, variant:String(item.variant), title:String(item.title || item.handle).slice(0,300), variantTitle:String(item.variantTitle || '').slice(0,200), image:safeImage(item.image || '')};
    if(item.priceReference && Number.isSafeInteger(item.priceReference.price) && item.priceReference.price>=0 && /^[A-Z]{3}$/.test(item.priceReference.currency) && Number.isFinite(item.priceReference.at) && item.priceReference.at>0) clean.priceReference={price:item.priceReference.price,currency:item.priceReference.currency,at:item.priceReference.at};
    return clean;
  }
  function createStore(storage, defaultName = 'Lieblingsstücke') {
    const nameOf = value => {
      const name = String(value || '').normalize('NFC').replace(/[\u0000-\u001f\u007f]/g,'').replace(/\s+/g,' ').trim();
      if (!name || name.length > 30) throw Error('invalid_name');
      return name;
    };
    const cleanItems = values => {
      if (!Array.isArray(values)) throw Error('storage_error');
      const normalized = values.map(normalize);
      if(normalized.some(item => !item)) throw Error('storage_error');
      return [...new Map(normalized.map(item => [keyOf(item),item])).values()];
    };
    const read = () => {
      const raw = storage.getItem(KEY);
      if (raw === null) {
        const legacy = storage.getItem(LEGACY_KEY);
        const previous = legacy === null ? {version:1,items:[]} : JSON.parse(legacy);
        if(previous.version !== 1) throw Error('storage_error');
        return {version:2, active:'default', lists:[{id:'default',name:defaultName,items:cleanItems(previous.items)}]};
      }
      const data = JSON.parse(raw);
      if (data.version !== 2 || !Array.isArray(data.lists) || !data.lists.length || data.lists.length > 3) throw Error('storage_error');
      const ids = new Set();
      data.lists = data.lists.map(list => {
        if(!/^[a-z0-9-]{1,50}$/.test(list.id) || ids.has(list.id)) throw Error('storage_error');
        ids.add(list.id);
        return {id:list.id,name:nameOf(list.name),items:cleanItems(list.items)};
      });
      if(!ids.has(data.active)) data.active = data.lists[0].id;
      return data;
    };
    const write = data => { storage.setItem(KEY, JSON.stringify(data)); return data; };
    const find = (data,id) => { const list = data.lists.find(list=>list.id===id); if(!list) throw Error('list_missing'); return list; };
    const add = (item,listId) => {
      const clean = normalize(item);
      if (!clean) throw Error('choose');
      const data = read();
      const items = find(data,listId || data.active).items;
      if (items.some(entry => keyOf(entry) === keyOf(clean))) return items;
      if (items.length >= 100) throw Error('limit');
      items.unshift(clean); write(data); return items;
    };
    const remove = (key,listId) => { const data=read(); const list=find(data,listId || data.active); list.items=list.items.filter(item=>keyOf(item)!==key); write(data); return list.items; };
    const select = id => { const data=read(); find(data,id); data.active=id; return write(data); };
    const create = value => {
      const data=read(); if(data.lists.length>=3) throw Error('max_lists');
      const name=nameOf(value); if(data.lists.some(l=>l.name.toLocaleLowerCase('de')===name.toLocaleLowerCase('de'))) throw Error('duplicate_name');
      const id=crypto.randomUUID(); data.lists.push({id,name,items:[]}); data.active=id; return write(data);
    };
    const rename = (id,value) => {
      const data=read(),name=nameOf(value);
      if(data.lists.some(l=>l.id!==id && l.name.toLocaleLowerCase('de')===name.toLocaleLowerCase('de'))) throw Error('duplicate_name');
      find(data,id).name=name; return write(data);
    };
    const deleteEmpty = id => {
      const data=read(); if(data.lists.length===1 || find(data,id).items.length) throw Error('list_missing');
      data.lists=data.lists.filter(list=>list.id!==id); if(data.active===id) data.active=data.lists[0].id; return write(data);
    };
    const memberships = (item,ids) => {
      const data=read(),clean=normalize(item); if(!clean) throw Error('choose');
      ids.forEach(id=>find(data,id));
      for(const list of data.lists){
        const present=list.items.some(entry=>keyOf(entry)===keyOf(clean));
        if(ids.includes(list.id) && !present){ if(list.items.length>=100) throw Error('limit'); list.items.unshift(clean); }
        else if(!ids.includes(list.id)) list.items=list.items.filter(entry=>keyOf(entry)!==keyOf(clean));
      }
      return write(data);
    };
    const priceReference = (item,price,currency) => {
      if(!Number.isSafeInteger(price) || price<0 || !/^[A-Z]{3}$/.test(currency)) return null;
      const data=read(),matches=data.lists.flatMap(list=>list.items).filter(entry=>keyOf(entry)===keyOf(item));
      if(!matches.length) return null;
      const known=matches.map(entry=>entry.priceReference).find(ref=>ref?.currency===currency);
      const reference=known || {price,currency,at:Date.now()};
      let changed=false;
      matches.forEach(entry=>{if(!entry.priceReference || entry.priceReference.currency!==currency){entry.priceReference=reference;changed=true;}});
      if(changed) write(data);
      return {reference,first:!known};
    };
    return {read, add, remove, select, create, rename, deleteEmpty, memberships, priceReference};
  }
  const dialog = document.getElementById('wadl-wohnideen');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const strings = JSON.parse(dialog.querySelector('[data-wi-strings]').textContent);
  const toast = document.querySelector('[data-wi-toast]');
  const toastHome = toast.parentNode;
  const message = toast.querySelector('[data-wi-message]');
  const undo = toast.querySelector('[data-wi-undo]');
  const list = dialog.querySelector('[data-wi-list]');
  const status = dialog.querySelector('[data-wi-status]');
  const root = dialog.dataset.root;
  const tabs = dialog.querySelector('[data-wi-collections]');
  const edit = dialog.querySelector('[data-wi-edit]');
  const picker = dialog.querySelector('[data-wi-picker]');
  const cartStates = new Map();
  let store;
  try { store = createStore(window.localStorage,strings.default_list); } catch { store = createStore({getItem(){throw Error('storage_error');}}); }
  let data = {lists:[],active:null}, editing = null, pickerItem = null;
  let items = [], removed = null, timer, opener, revision = 0, frame;
  const copy = key => strings[key] || strings.storage_error;
  const activeList = () => data.lists.find(list=>list.id===data.active);
  const mutate = action => navigator.locks ? navigator.locks.request(KEY,action) : Promise.resolve().then(action);
  const errorKey = error => ['limit','choose','max_lists','invalid_name','duplicate_name','list_missing'].includes(error.message) ? error.message : 'storage_error';
  const say = (key, canUndo = false, suffix = '') => {
    clearTimeout(timer);
    message.textContent = `${copy(key)}${suffix ? ' '+suffix : ''}`;
    undo.hidden = !canUndo;
    (dialog.open ? dialog : toastHome).append(toast);
    toast.hidden = false;
    if (!canUndo && !['storage_error','offline','limit'].includes(key)) timer = setTimeout(() => {toast.hidden = true;}, 7000);
  };
  const selected = button => {
    const form = button.dataset.form && document.getElementById(button.dataset.form);
    const info = button.closest('product-info');
    const variant = info?.dataset.wiPending ? '' : form ? form.querySelector('[name="id"]')?.value : button.dataset.variant;
    let variantTitle = form ? '' : button.dataset.variantTitle;
    try {
      const current = JSON.parse(info?.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null');
      if (current && String(current.id) === variant) variantTitle = current.title;
    } catch {}
    return {...button.dataset,variant,variantTitle};
  };
  const refresh = () => {
    try { data = store.read(); items = activeList()?.items || []; } catch { say('storage_error'); }
    const allItems = data.lists.flatMap(list=>list.items);
    document.querySelectorAll('[data-wi-save]').forEach(button => {
      const saved = allItems.some(item => keyOf(item) === keyOf(selected(button)));
      button.hidden = false;
      const pressed = String(saved);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed',pressed);
      const label = saved ? copy('saved') : copy('save');
      button.setAttribute('aria-label', `${label}: ${button.dataset.title}`);
      const text = button.querySelector('[data-wi-label]');
      if (text && text.textContent !== label) text.textContent = label;
    });
    document.querySelectorAll('[data-wi-open]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-wi-count]').forEach(counter => {
      const count = new Set(allItems.map(keyOf)).size;
      if(counter.textContent !== String(count)) counter.textContent = String(count);
      counter.hidden = !count;
    });
    tabs.replaceChildren(...data.lists.map(list=>{
      const button=element('button',`${list.name} (${list.items.length})`); button.type='button'; button.dataset.wiList=list.id; button.setAttribute('aria-pressed',String(list.id===data.active)); return button;
    }));
    dialog.querySelector('[data-wi-new]').disabled=data.lists.length>=3;
    dialog.querySelector('[data-wi-delete]').hidden=data.lists.length<=1 || !!items.length;
  };
  const urlFor = item => `${root}products/${encodeURIComponent(item.handle)}?variant=${item.variant}`;
  const element = (tag, text, cls) => { const node = document.createElement(tag); if(text) node.textContent = text; if(cls) node.className = cls; return node; };
  const infoPopover=element('div','','wi-info-popover'); infoPopover.id='wi-status-info'; infoPopover.setAttribute('role','tooltip'); infoPopover.setAttribute('popover','manual'); dialog.append(infoPopover);
  let infoButton=null,infoPinned=false,infoTimer;
  const closeInfo=()=>{clearTimeout(infoTimer);infoPopover.hidePopover?.();infoButton?.setAttribute('aria-expanded','false');infoButton=null;infoPinned=false;};
  const showInfo=(button,text,pinned=false)=>{
    closeInfo();infoButton=button;infoPinned=pinned;infoPopover.textContent=text;button.setAttribute('aria-expanded','true');infoPopover.showPopover?.();
    const rect=button.getBoundingClientRect(),box=infoPopover.getBoundingClientRect();
    infoPopover.style.left=Math.max(16,Math.min(rect.left,window.innerWidth-box.width-16))+'px';
    infoPopover.style.top=Math.max(16,rect.bottom+8+box.height>window.innerHeight-16?rect.top-box.height-8:rect.bottom+8)+'px';
  };
  const laterClose=()=>{if(!infoPinned)infoTimer=setTimeout(closeInfo,160);};
  infoPopover.addEventListener('pointerenter',()=>clearTimeout(infoTimer));infoPopover.addEventListener('pointerleave',laterClose);
  dialog.addEventListener('click',event=>{if(!event.target.closest('.wi-info-button,.wi-info-popover'))closeInfo();});
  dialog.addEventListener('keydown',event=>{if(event.key==='Escape'&&infoButton){event.preventDefault();event.stopPropagation();closeInfo();}},true);
  dialog.addEventListener('close',closeInfo);dialog.addEventListener('scroll',closeInfo);window.addEventListener('resize',closeInfo);
  const statusSvg=symbol=>{
    const paths={check:'m5 12 4 4 10-10',warning:'M12 6v7 M12 17h.01',minus:'M6 12h12',clock:'M12 5v7l4 2',info:'M12 11v7 M12 7h.01',down:'M5 7l5 5 4-3 5 7 M14 16h5v-5',up:'M5 17l5-5 4 3 5-7 M14 8h5v5',same:'M5 9h14 M5 15h14',sale:'M7 17 17 7 M7 7h.01 M17 17h.01'};
    Object.assign(paths,{demand_up:'M4 4v16h16 M8 16v-3 M13 16V9 M18 16V5',demand_down:'M4 4v16h16 M8 16V5 M13 16V9 M18 16v-3',demand_same:'M4 4v16h16 M8 16V9 M13 16V9 M18 16V9'});
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    for(const [key,value] of Object.entries({viewBox:'0 0 24 24',width:'17',height:'17',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(key,value);
    const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d',paths[symbol]||paths.info);svg.append(path);return svg;
  };
  const stockInfo=(current,stock)=>{
    if(!current)return {symbol:'info',text:copy('unavailable'),tone:'neutral'};
    if(!current.available)return {symbol:'minus',text:copy('sold_out'),tone:'stock-out'};
    const states={in_stock:['check','stock_in','stock-in'],low:['warning','stock_low','stock-low'],backorder:['clock','stock_backorder','stock-in']};
    const [symbol,key,tone]=states[stock]||['info','available_info','neutral'];return {symbol,text:copy(key),tone};
  };
  const infoIcon=(symbol,text,tone='neutral')=>{
    const button=element('button','','wi-info-button');button.type='button';button.dataset.tone=tone;button.setAttribute('aria-label',text);button.setAttribute('aria-describedby',infoPopover.id);button.setAttribute('aria-expanded','false');
    const glyph=element('span');glyph.setAttribute('aria-hidden','true');glyph.append(statusSvg(symbol));button.append(glyph);
    button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')showInfo(button,text);});button.addEventListener('pointerleave',laterClose);
    button.addEventListener('focus',()=>showInfo(button,text));button.addEventListener('blur',()=>{if(infoButton===button)closeInfo();});
    button.addEventListener('click',()=>{if(infoButton===button&&infoPinned)closeInfo();else showInfo(button,text,true);});return button;
  };
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:dialog.dataset.currency}).format(value/100);
  const priceInfo=(current,result)=>{
    if(!result || result.first)return {symbol:'clock',text:copy('price_first')};
    const delta=current.price-result.reference.price;
    const date=new Intl.DateTimeFormat(document.documentElement.lang||'de-DE').format(new Date(result.reference.at));
    return {symbol:delta<0?'down':delta>0?'up':'same',tone:delta<0?'good':'neutral',text:copy(delta<0?'price_down':delta>0?'price_up':'price_same').replace('[date]',date).replace('[price]',money(result.reference.price)).replace('[difference]',money(Math.abs(delta)))};
  };
  const demandInfo=(productId,now=Date.now())=>{
    try {
      if(JSON.parse(dialog.querySelector('[data-wi-strings]').textContent).demand_enabled===false)return null;
      const snapshot=JSON.parse(document.getElementById('wadl-recs-trends')?.textContent||'null');
      const age=now-Date.parse(snapshot?.generatedAt),through=Date.parse(snapshot?.through+'T12:00:00Z');
      if(snapshot?.version!==1||!Number.isFinite(age)||age<0||age>72*3600000||!/^\d{4}-\d{2}-\d{2}$/.test(snapshot.through)||!Number.isFinite(through)||through>now)return null;
      const value=snapshot.demand?.[String(productId)],valid=direction=>['up','down','same'].includes(direction);
      if(!value||!valid(value.direction)||![value.seven,value.thirty].some(valid)||[value.seven,value.thirty].some(v=>v!==null&&!valid(v)))return null;
      const label=direction=>copy(valid(direction)?'demand_'+direction:'demand_missing');
      const date=new Intl.DateTimeFormat(document.documentElement.lang||'de-DE',{timeZone:'Europe/Berlin'}).format(new Date(through));
      return {symbol:'demand_'+value.direction,text:label(value.direction)+'. '+copy('demand_detail').replace('[seven]',label(value.seven)).replace('[thirty]',label(value.thirty)).replace('[date]',date)};
    }catch{return null;}
  };
  const requestProduct = async item => {
    const response = await fetch(`${urlFor(item)}&section_id=wadl-wohnideen-product`, {signal:AbortSignal.timeout(12000)});
    if (!response.ok) throw Error(response.status === 404 ? 'unavailable' : 'offline');
    const doc = new DOMParser().parseFromString(await response.text(),'text/html');
    const payload = doc.querySelector('[data-wi-product]');
    if(!payload) throw Error('offline');
    const product=JSON.parse(payload.textContent);
    if(!product || product.handle!==item.handle || !Array.isArray(product.variants)) throw Error('unavailable');
    const policy=doc.querySelector('[data-wi-cart-policy]');
    const exact=policy?.dataset.variant===item.variant;
    return {product,allowed:exact && policy.dataset.allowed==='true',stock:exact?policy.dataset.stock:'unknown'};
  };
  const show = button => {if(!dialog.open){opener=button;dialog.showModal();document.documentElement.classList.add('wi-locked');} render();};
  const openPicker = (candidate,button) => {
    const clean=normalize(candidate); if(!clean) throw Error('choose');
    pickerItem=clean; show(button); edit.hidden=true; picker.hidden=false;
    picker.querySelector('[data-wi-picker-title]').textContent=`${copy('select_lists')}: ${clean.title}`;
    const selectedIds=data.lists.filter(list=>list.items.some(item=>keyOf(item)===keyOf(clean))).map(list=>list.id);
    picker.querySelector('[data-wi-choices]').replaceChildren(...data.lists.map(list=>{
      const label=element('label'),input=element('input'); input.type='checkbox';input.name='list_id';input.value=list.id;input.checked=selectedIds.length ? selectedIds.includes(list.id) : list.id===data.active; label.append(input,element('span',list.name)); return label;
    }));
    picker.querySelector('[data-wi-picker-error]').textContent=''; picker.querySelector('input').focus();
  };
  const updateCartButtons = () => {
    dialog.querySelectorAll('[data-wi-cart]').forEach(button=>{
      const state=cartStates.get(button.dataset.wiCart);
      button.disabled=!!state;
      button.textContent=copy(state==='pending' ? 'cart_pending' : state==='added' ? 'cart_added' : state ? 'cart_view' : 'cart_add');
    });
  };
  const addToCart = async (item,button) => {
    const key=keyOf(item); if(cartStates.has(key)) return;
    cartStates.set(key,'pending');updateCartButtons();
    let posted=false;
    try {
      const fresh=await requestProduct(item);
      const variant=fresh.product.variants.find(v=>String(v.id)===item.variant);
      if(!fresh.allowed) throw Error('cart_product');
      if(!variant?.available) throw Error('sold_out');
      posted=true;
      const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:item.variant,quantity:1}],sections:['cart-icon-bubble'],sections_url:location.pathname}),signal:AbortSignal.timeout(15000)});
      const result=await response.json();
      if(!response.ok || result.status) throw Error('cart_error');
      if(!result.items?.some(entry=>String(entry.variant_id || entry.id)===item.variant)) throw Error('cart_unknown');
      cartStates.set(key,'added');
      say('cart_added');
      const note=button.closest('.wi-item')?.querySelector('[data-wi-cart-message]');if(note) note.textContent=copy('cart_added');
      try {
        const html=result.sections?.['cart-icon-bubble'];
        const target=document.getElementById('cart-icon-bubble');
        if(html && target){const section=new DOMParser().parseFromString(html,'text/html').querySelector('.shopify-section');if(section) target.replaceChildren(...section.childNodes);}
        if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate,{source:'wohnideen',cartData:result})).catch(()=>{});
      } catch {}
    } catch(error) {
      const code=posted ? (error.message==='cart_error' ? 'cart_error' : 'cart_unknown') : ['cart_product','sold_out'].includes(error.message) ? error.message : 'offline';
      if(posted) cartStates.set(key,'unknown');else cartStates.delete(key);
      const note=button.closest('.wi-item')?.querySelector('[data-wi-cart-message]');if(note) note.textContent=copy(code);
      say(code);
    } finally {updateCartButtons();}
  };
  const render = async () => {
    closeInfo();
    const run = ++revision;
    refresh();
    const listId=data.active;
    list.replaceChildren();
    dialog.querySelector('[data-wi-empty]').hidden = !!items.length;
    status.textContent = items.length ? copy('loading') : '';
    const tasks = items.map(item => {
      const li = element('li', '', 'wi-item');
      const photoLink = element('a'); photoLink.href = urlFor(item); photoLink.tabIndex = -1; photoLink.setAttribute('aria-hidden','true');
      const photo = element('img','','wi-image'); photo.alt = ''; photo.width = 110; photo.height = 136; photo.loading = 'lazy';
      if(item.image) photo.src = item.image; else photo.hidden = true;
      photoLink.append(photo);
      const body = element('div');
      const heading = element('h3'); const link = element('a',item.title); link.href = urlFor(item); heading.append(link);
      const variant = element('p', item.variantTitle === 'Default Title' ? '' : item.variantTitle);
      const price = element('div','','wi-price-status');
      const state = element('p',copy('loading'));
      const actions = element('div','','wi-actions');
      const view = element('a',copy('view')); view.href = urlFor(item);
      const cartButton=element('button',copy('cart_add'),'wi-primary');cartButton.type='button';cartButton.dataset.wiCart=keyOf(item);cartButton.hidden=true;
      cartButton.addEventListener('click',()=>addToCart(item,cartButton));
      const cartView=element('a',copy('cart_view'));cartView.href=`${root}cart`;cartView.dataset.wiCartView='';
      const cartMessage=element('p','','wi-cart-message');cartMessage.dataset.wiCartMessage='';cartMessage.setAttribute('role','status');
      const remove = element('button',copy('remove'),'wi-remove'); remove.type = 'button'; remove.dataset.wiRemove = keyOf(item); remove.setAttribute('aria-label',`${copy('remove')}: ${item.title}`);
      remove.dataset.listId=listId;
      const organize=element('button',copy('select_lists'),'wi-remove');organize.type='button';organize.hidden=data.lists.length<2;organize.addEventListener('click',()=>openPicker(item,organize));
      actions.append(cartButton,view,remove,organize); body.append(heading,variant,price,state,actions,cartMessage); li.append(photoLink,body); list.append(li);
      if(cartStates.has(keyOf(item))) {cartMessage.textContent=copy(cartStates.get(keyOf(item))==='added'?'cart_added':'cart_unknown');cartMessage.append(' ',cartView);}
      return async () => {
        try {
          const {product,allowed,stock} = await requestProduct(item);
          if(run !== revision) return true;
          const current = product.variants.find(value => String(value.id) === item.variant);
          link.textContent = product.title;
          variant.textContent = current && current.title !== 'Default Title' ? current.title : '';
          state.textContent = !current ? copy('unavailable') : current.available ? '' : copy('sold_out');
          let reference=null;
          if(current){try{reference=await mutate(()=>store.priceReference(item,current.price,dialog.dataset.currency));}catch{}}
          if(run !== revision) return true;
          price.replaceChildren(element('span',current?money(current.price):'—'));
          const availability=stockInfo(current,stock);price.append(infoIcon(availability.symbol,availability.text,availability.tone));
          if(current){
            const trend=priceInfo(current,reference);price.append(infoIcon(trend.symbol,trend.text,trend.tone));
            const demand=demandInfo(product.id);if(demand){const icon=infoIcon(demand.symbol,demand.text);icon.dataset.wiDemand=demand.symbol;price.append(icon);}
            if(current.compare_at_price>current.price)price.append(infoIcon('sale',copy('sale_info').replace('[price]',money(current.compare_at_price)),'good'));
            if(current.available&&!allowed)price.append(infoIcon('info',copy('cart_product')));
          }
          cartButton.hidden=!allowed || !current?.available;
          if(current?.available && !allowed) state.textContent=copy('cart_product');
          if(cartStates.has(keyOf(item)) && !cartMessage.contains(cartView)) cartMessage.append(' ',cartView);
          updateCartButtons();
          const src = safeImage(current?.featured_image?.src || product.featured_image || '');
          if(src) {photo.src = src; photo.hidden = false;}
          return true;
        } catch (error) { if(run === revision) {const text=copy(error.message === 'unavailable' ? 'unavailable' : 'offline');state.textContent=text;price.replaceChildren(element('span','—'),infoIcon('info',text));} return false; }
      };
    });
    let failed = false;
    const worker = async () => { while(tasks.length && run === revision && dialog.open) { if(!await tasks.shift()()) failed = true; } };
    await Promise.all(Array.from({length:Math.min(4,tasks.length)},worker));
    if(run !== revision) return;
    status.textContent = failed ? copy('offline') : '';
    if(failed) {const retry = element('button',copy('retry')); retry.type = 'button'; retry.dataset.wiRetry = ''; status.append(' ',retry);}
  };
  edit.addEventListener('submit',async event=>{
    event.preventDefault();const task=editing;if(!task || edit.dataset.busy) return;
    edit.dataset.busy='true';edit.querySelector('[type="submit"]').disabled=true;
    try {
      const name=edit.querySelector('input').value;
      await mutate(()=>task.mode==='new' ? store.create(name) : store.rename(task.id,name));
      edit.hidden=true;editing=null;render();say('list_updated');tabs.querySelector('[aria-pressed="true"]')?.focus();
    } catch(error){edit.querySelector('[data-wi-edit-error]').textContent=copy(errorKey(error));}
    finally{delete edit.dataset.busy;edit.querySelector('[type="submit"]').disabled=false;}
  });
  picker.addEventListener('submit',async event=>{
    event.preventDefault();if(!pickerItem || picker.dataset.busy) return;
    picker.dataset.busy='true';picker.querySelector('[type="submit"]').disabled=true;
    try {
      const item=pickerItem, ids=[...picker.querySelectorAll('input:checked')].map(input=>input.value);
      await mutate(()=>store.memberships(item,ids));picker.hidden=true;pickerItem=null;render();say('memberships_saved');tabs.querySelector('[aria-pressed="true"]')?.focus();
    } catch(error){picker.querySelector('[data-wi-picker-error]').textContent=copy(errorKey(error));}
    finally{delete picker.dataset.busy;picker.querySelector('[type="submit"]').disabled=false;}
  });
  let openingCart = false;
  dialog.addEventListener('click',async event => {
    const link = event.target.closest('[data-wi-cart-view]');
    const drawer = document.querySelector('cart-drawer');
    if (!link || !drawer || typeof drawer.open !== 'function' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (openingCart) return;
    openingCart = true; link.setAttribute('aria-busy','true');
    try {
      const response = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`, {signal:AbortSignal.timeout(12000)});
      if (!response.ok) throw Error('offline');
      const sections = await response.json();
      const fresh = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
      const freshDrawer = fresh.querySelector('cart-drawer');
      if (!freshDrawer?.querySelector('#CartDrawer') || !sections['cart-icon-bubble']) throw Error('offline');
      if (!dialog.open) return;
      const target = drawer.querySelector('#CartDrawer');
      if (!target) throw Error('offline');
      target.innerHTML = freshDrawer.querySelector('#CartDrawer').innerHTML;
      const icon = document.getElementById('cart-icon-bubble');
      const iconDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
      if (icon) icon.innerHTML = (iconDoc.querySelector('.shopify-section') || iconDoc.body).innerHTML;
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
      await new Promise(resolve => { dialog.addEventListener('close',resolve,{once:true}); dialog.close(); });
      drawer.classList.toggle('is-empty',freshDrawer.classList.contains('is-empty'));
      drawer.open(icon || opener);
    } catch (_) { if (dialog.open) say('offline'); }
    finally { openingCart = false; link.removeAttribute('aria-busy'); }
  });
  document.addEventListener('click',async event => {
    const button = event.target.closest('button');
    if(!button) return;
    if(button.matches('[data-wi-open]')) {
      show(button);
    } else if(button.matches('[data-wi-close]')) { dialog.close(); }
    else if(button.matches('[data-wi-toast-close]')) {toast.hidden = true;}
    else if(button.matches('[data-wi-retry]')) {render();}
    else if(button.matches('[data-wi-new], [data-wi-rename]')) {
      refresh();editing={mode:button.matches('[data-wi-new]')?'new':'rename',id:data.active};
      picker.hidden=true;edit.hidden=false;edit.querySelector('input').value=editing.mode==='new'?'':activeList()?.name || '';edit.querySelector('[data-wi-edit-error]').textContent='';edit.querySelector('input').focus();
    } else if(button.matches('[data-wi-cancel]')) {edit.hidden=true;editing=null;dialog.querySelector('[data-wi-rename]').focus();}
    else if(button.matches('[data-wi-picker-cancel]')) {picker.hidden=true;pickerItem=null;dialog.querySelector('[data-wi-close]').focus();}
    else if(button.matches('[data-wi-list], [data-wi-delete]')) {
      try {
        await mutate(()=>button.matches('[data-wi-delete]') ? store.deleteEmpty(data.active) : store.select(button.dataset.wiList));
        edit.hidden=true;picker.hidden=true;render();tabs.querySelector('[aria-pressed="true"]')?.focus();
      } catch(error){say(errorKey(error));}
    }
    else if(button.matches('[data-wi-save], [data-wi-remove], [data-wi-undo]')) {
      event.preventDefault();
      try {
        if(button.matches('[data-wi-undo]')) { const previous=removed;if(previous) await mutate(()=>store.add(previous.item,previous.listId));removed=null;say('restored'); }
        else {
          const candidate = button.matches('[data-wi-save]') ? selected(button) : null;
          refresh();
          if(candidate && data.lists.length>1) {openPicker(candidate,button);return;}
          const key = candidate ? keyOf(candidate) : button.dataset.wiRemove;
          const listId=candidate ? data.active : button.dataset.listId;
          await mutate(()=>{
            const latest=store.read(),collection=latest.lists.find(list=>list.id===listId);
            if(!collection) throw Error('list_missing');
            const existing=collection.items.find(item=>keyOf(item)===key);
            if(existing){store.remove(key,listId);removed={item:existing,listId};say('removed',true);}
            else if(candidate){store.add(candidate,listId);say('added',false,`„${collection.name}“`);}
          });
        }
        refresh();
        if(dialog.open) {render(); undo.hidden ? dialog.querySelector('[data-wi-close]').focus() : undo.focus();}
      } catch(error) { say(errorKey(error)); }
    }
  });
  dialog.addEventListener('click',event => { if(event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
  dialog.addEventListener('close',() => { revision++; document.documentElement.classList.remove('wi-locked'); toastHome.append(toast); opener?.focus(); });
  document.addEventListener('change',event => {
    const info = event.target.closest('product-info');
    if (info && event.target.closest('variant-selects')) info.dataset.wiPending = 'true';
    if(event.target.matches('[name="id"]')) {if(info) delete info.dataset.wiPending; refresh();}
  });
  window.addEventListener('storage',event => {if([KEY,LEGACY_KEY,null].includes(event.key)) {refresh(); if(dialog.open) render();}});
  new MutationObserver(records => {
    if(records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-wi-save], [data-wi-open]') || node.querySelector('[data-wi-save], [data-wi-open]'))))) {
      cancelAnimationFrame(frame); frame = requestAnimationFrame(refresh);
    }
  }).observe(document.body,{childList:true,subtree:true});
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
